import React, { useMemo } from 'react'
import { usePageLayout } from '../hooks/usePageLayout'

function Work() {
  // Memoize layout options to prevent infinite re-renders
  const layoutOptions = useMemo(
    () => ({
      showSidebar: true,
      showHeader: true,
      showFooter: true,
      title: {
        en: 'Our Projects',
        zh_cn: '我们的项目',
        zh_hk: '我們的項目',
      },
    }),
    [],
  )

  // Work page should show all navigation elements
  usePageLayout(layoutOptions)

  return (
    <>
      <h1 className="mt-40 ml-44 text-4xl font-extrabold">Our Projects</h1>
    </>
  )
}

export default Work
